import PayeReportComponent from 'components/Report/PayeReport';
import PermissionGuard from 'components/Global/PermissionGuard'; 

const PayeReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<PayeReportComponent />
		</PermissionGuard>
	);
};

export default PayeReport;
